import { IUser } from "../../../model/respone/user/IUser";
import { IActionTypeBase } from "../IActionTypeBase";

export enum eUserActionTypeIds {
    LOAD_START = "LOAD_START",
    LOAD_SUCCESS = "LOAD_SUCCESS",
    LOAD_ERROR = "LOAD_ERROR",

    CHANGE_SELECTED_IDS = "CHANGE_SELECTED_IDS",

    SHOW_EDIT_MODAL = "SHOW_EDIT_MODAL",
    CLOSE_EDIT_MODAL = "CLOSE_EDIT_MODAL",

    SAVE_START = "SAVE_START",
    SAVE_SUCCESS = "SAVE_SUCCESS",
    SAVE_ERROR = "SAVE_ERROR",

    DELETE_START = "DELETE_START",
    DELETE_SUCCESS = "DELETE_SUCCESS",
    DELETE_ERROR = "DELETE_ERROR",

}
export interface IUserLoadStart extends IActionTypeBase<eUserActionTypeIds.LOAD_START, undefined> { }
export interface IUserLoadSuccess extends IActionTypeBase<eUserActionTypeIds.LOAD_SUCCESS, IUser[]> { }
export interface IUserLoadError extends IActionTypeBase<eUserActionTypeIds.LOAD_ERROR, string| undefined> { }

export interface IUserChangeSelectedIds extends IActionTypeBase<eUserActionTypeIds.CHANGE_SELECTED_IDS, number[]> { }

export interface IUserShowEditModal extends IActionTypeBase<eUserActionTypeIds.SHOW_EDIT_MODAL, IUser | undefined> { }
export interface IUserCloseEditModal extends IActionTypeBase<eUserActionTypeIds.CLOSE_EDIT_MODAL, undefined> { }

export interface IUserSaveStart extends IActionTypeBase<eUserActionTypeIds.SAVE_START, IUser> { }
export interface IUserSaveSuccess extends IActionTypeBase<eUserActionTypeIds.SAVE_SUCCESS, IUser> { }
export interface IUserSaveError extends IActionTypeBase<eUserActionTypeIds.SAVE_ERROR, string> { }

export interface IUserDeleteStart extends IActionTypeBase<eUserActionTypeIds.DELETE_START, number[]> { }
export interface IUserDeleteSuccess extends IActionTypeBase<eUserActionTypeIds.DELETE_SUCCESS, undefined> { }
export interface IUserDeleteError extends IActionTypeBase<eUserActionTypeIds.DELETE_ERROR, string> { }

export type IUserActionTypes = IUserLoadStart | IUserLoadSuccess | IUserLoadError |
    IUserChangeSelectedIds |
    IUserShowEditModal |IUserCloseEditModal|
    IUserSaveStart | IUserSaveSuccess | IUserSaveError |
    IUserDeleteStart |IUserDeleteSuccess|IUserDeleteError
